import {
  CreateBusinessPartnerRequestDto,
  UpdateBusinessPartnerRequestDto,
} from "~/gen/api"
import { SupplierFormValues } from "~/pages/Brand/Suppliers/SuppliersRepository/hooks/columns"

export type SupplierMapping =
  | CreateBusinessPartnerRequestDto
  | UpdateBusinessPartnerRequestDto

export const toSupplierMappingPayload = (
  values: SupplierFormValues,
  options: { omitContactFields: boolean; omitCanAnswerOnBehalf: boolean }
): SupplierMapping => {
  if ("contactId" in values) {
    const {
      contactId: _contactId,
      businessRelationshipId: _businessRelationshipId,
      supplierId,
      organization,
      canAnswerOnBehalf,
      name,
      email,
      preferedLangageIso6391,
    } = values

    const includeCanAnswerOnBehalf =
      !options.omitCanAnswerOnBehalf && canAnswerOnBehalf !== undefined

    if (options.omitContactFields) {
      return {
        supplierId,
        organization,
        ...(includeCanAnswerOnBehalf ? { canAnswerOnBehalf } : {}),
      }
    }

    return {
      supplierId,
      name,
      email,
      preferedLangageIso6391,
      organization,
      ...(includeCanAnswerOnBehalf ? { canAnswerOnBehalf } : {}),
    }
  }

  const {
    businessRelationshipId: _businessRelationshipId,
    organization,
    canAnswerOnBehalf,
    repositoryRecord,
    duplicateCandidateId,
    name,
    email,
    preferedLangageIso6391,
  } = values

  const includeCanAnswerOnBehalf =
    !options.omitCanAnswerOnBehalf && canAnswerOnBehalf !== undefined

  if (options.omitContactFields) {
    return {
      organization,
      ...(includeCanAnswerOnBehalf ? { canAnswerOnBehalf } : {}),
      ...(repositoryRecord !== undefined ? { repositoryRecord } : {}),
      ...(duplicateCandidateId !== undefined ? { duplicateCandidateId } : {}),
    }
  }

  return {
    organization,
    ...(name !== undefined ? { name } : {}),
    ...(email !== undefined ? { email } : {}),
    ...(preferedLangageIso6391 !== undefined ? { preferedLangageIso6391 } : {}),
    ...(includeCanAnswerOnBehalf ? { canAnswerOnBehalf } : {}),
    ...(repositoryRecord !== undefined ? { repositoryRecord } : {}),
    ...(duplicateCandidateId !== undefined ? { duplicateCandidateId } : {}),
  }
}

export const toPolicyAwarePayload = (
  values: SupplierFormValues,
  options: { isUpdate: boolean; existingCanAnswerOnBehalf: boolean }
): SupplierMapping =>
  toSupplierMappingPayload(values, {
    omitContactFields: !options.isUpdate && values.canAnswerOnBehalf === true,
    omitCanAnswerOnBehalf: options.isUpdate,
  })
